<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
    >
      <v-text-field
          single-line
          outlined
          dense
          clearable
          class="dark-primary"
          :disabled="isLoading"
          v-model="search.value" label="Поиск по номеру и марке" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
      </v-text-field>
      <v-spacer></v-spacer>
      <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          class="mr-0 dark-primary"
          @click="newCar"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
        <v-btn
            text
            @click="newCar"
            class="dark-primary rounded-tr-lg"
        >
          Добавить автомобиль
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.number="props">
        <span style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">{{props.item.number}}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="editCar(item)"
                v-bind="attrs"
                v-on="on"
            >
              edit
            </v-icon>
          </template>
          <span>Редактировать</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="deleteCar(item)"
                v-bind="attrs"
                v-on="on"
            >
              delete
            </v-icon>
          </template>
          <span>Удалить</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="updateData"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :car-data="cars_data"
        @close="closeEditDialog"
    ></EditDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
  </v-container>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import EditDialog from "../components/CarsEditDialog";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import names from "@/modules/admin/routers/names";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";

export default {
  name: "AdminCarsList",
  components: {EditDialog, ApplyDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список автомобилей",
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      cars_data: undefined,
      search: {
        parameter: "search"
      },
      headers: [
        {text: "Номер", value: "number", align: "start", sortable: true, width: "40%"},
        {text: "Марка", value: "model", align: "start", sortable: true, width: "40%"},
        {text: "Действия", value: "actions", align: "center", sortable: false, width: "20%"}
      ]
    }
  },
  computed: {
    ...mapGetters({
      items: "admin/getCars",
      count: "admin/getCarsCount",
      isLoading: "admin/isLoadingCars",
      getCurrentUrl: "admin/getCurrentUrl"
    })
  },
  watch: {},
  methods: {
    ...mapActions({
      loadCarsList: "admin/loadCarsList",
      deleteCars: "admin/deleteCars"
    }),
    getDetail(item) {
      this.$router.push({name: names.CARS.DETAIL, params: {idCars: item.id}}).catch(() => {})
    },
    updateData(){
      if (this.search.value) {
        this.search.value = ""
      }
      this.loadData()
    },
    loadData(url = undefined) {
      this.loadCarsList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          return new_url
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newCar() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.cars_data = undefined
    },
    editCar(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.cars_data = item
    },
    deleteCar(item) {
      this.dialog_delete = true
      this.cars_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.cars_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteCars({
          id: this.cars_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.cars_data = undefined
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
